import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ThesisPage = () => {
  return (
    <div className="min-h-screen bg-purple-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(255,255,255,.1)_1px,transparent_1px),linear-gradient(rgba(255,255,255,.1)_1px,transparent_1px)] bg-[size:4rem_4rem]" />
      
      <motion.div 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="fixed top-8 left-8"
      >
        <Link to="/" className="flex items-center text-white hover:text-cyan-400">
          <ArrowLeft className="w-6 h-6 mr-2" />
          Back
        </Link>
      </motion.div>

      <div className="relative max-w-4xl mx-auto px-4 pt-24 pb-16">
        <motion.h1 
          className="text-5xl font-bold mb-12 bg-gradient-to-r from-pink-500 to-cyan-500 text-transparent bg-clip-text"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          The Authenticity Fund: Investing in Human Value After AGI
        </motion.h1>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4 text-cyan-400">The Great Bifurcation</h2>
          <p className="text-lg text-purple-200">We stand at the precipice of the most profound economic transformation in human history. Within the next 5-10 years, artificial general intelligence will automate essentially all traditional labor. The market will bifurcate into two realms: AGI-dominated commodity services and fundamental scarcities that automation cannot eliminate.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4 text-cyan-400">Core Thesis: The Three Foundations of Post-Automation Value</h2>
          <ul className="list-disc pl-6 text-lg text-purple-200">
            <li><strong>Human Authenticity:</strong> Imperfection becomes more valuable, making human connection, art, and shared experiences irreplaceable.</li>
            <li><strong>Attention Networks:</strong> Infinite AI-generated content increases the value of human trust, influence, and curation.</li>
            <li><strong>Physical Rights:</strong> Scarce resources like prime locations, rare materials, and protected environments remain valuable.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4 text-cyan-400">Investment Framework</h2>
          <p className="text-lg text-purple-200">Traditional VC metrics become irrelevant. Instead, we assess investments based on:</p>
          <ul className="list-disc pl-6 text-lg text-purple-200">
            <li><strong>Persistence:</strong> Will this value endure through automation?</li>
            <li><strong>Authenticity:</strong> Does it capture genuine human dynamics?</li>
            <li><strong>Defensibility:</strong> Is the advantage based on fundamental rather than technical constraints?</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4 text-cyan-400">Portfolio Construction</h2>
          <p className="text-lg text-purple-200">We focus on ventures that build community infrastructure, capture attention networks, and secure physical rights:</p>
          <ul className="list-disc pl-6 text-lg text-purple-200">
            <li>Local creative guilds, social leagues, and physical venues</li>
            <li>Influence networks, trust-based curation, and human leadership</li>
            <li>Land rights, rare materials, and strategic real estate</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4 text-cyan-400">Beyond Returns: Measuring Success</h2>
          <p className="text-lg text-purple-200">Our metrics prioritize resilience, engagement, and human agency preservation over traditional profit models.</p>
        </section>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="text-center mt-16"
        >
          <Link 
            to="/competition"
            className="inline-block bg-gradient-to-r from-pink-500 to-cyan-500 text-white font-bold py-4 px-8 rounded-xl hover:opacity-90 transition-opacity"
          >
            Join Our Writing Competition
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default ThesisPage;

